import React, { useState, createContext, useContext, useCallback } from 'react';

export type FeatureState = Record<string, FeatureStatus>;
export enum FeatureStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

interface FeatureToggleContext {
  features: FeatureState;
  handleSetFeature: (value: FeatureState) => void;
}

const initialData: FeatureToggleContext = {
  features: {},
  handleSetFeature: (value: FeatureState) => {}
};

export const FeatureToggleContext = createContext<FeatureToggleContext>(initialData);

export const FeatureToggleProvider = ({ children }) => {
  const [features, setFeatures] = useState<FeatureState>({});

  const handleSetFeature = useCallback((data: FeatureState) => {
    setFeatures((state: FeatureState) => ({ ...state, ...data }));
  }, []);

  return (
    <FeatureToggleContext.Provider value={{ features, handleSetFeature }}>{children}</FeatureToggleContext.Provider>
  );
};

export const useFeatureToggleContext = (): FeatureToggleContext => {
  return useContext(FeatureToggleContext);
};
